module.exports = __webpack_public_path__ + "img/732.773dd98b.jpg";